<template>
  <div class="feature">
    <van-sticky>
      <van-nav-bar :border="false">
        <template #left>
          <span class="iconfont icon-houtui fs-24 fw-700" @click="$router.back()"></span>
        </template>
        <template #title>
          <strong>功能介绍</strong>
        </template>
      </van-nav-bar>
    </van-sticky>

    <div class="list">
      <mr-timeline v-for="item in featureList" :key="item.id" :timestamp="item.createtime * 1000 | formatTime" class="mr-timeline">
        <div class="card">
          <h3>{{ item.title }}</h3>
          <p class="content">{{ item.fileremark }}</p>
        </div>
      </mr-timeline>
    </div>
    <!-- <van-pull-refresh v-model="isLoading" class="flex-1" @refresh="onRefresh">
      <van-list v-model="loading" :finished="finished" :immediate-check="false" @load="onLoad">
        <van-cell v-for="item in featureList" center :title="item.title" :key="item.id" :label="item.createtime * 1000 | formatTime" is-link :to="'/feature-detail?catid='+ item.catid +'&id=' + item.id"></van-cell>
        <template v-if="featureList.length > 0" #finished>
          <span>没有更多了</span>
        </template>
        <van-empty v-if="featureList.length === 0" description="暂无数据" />
      </van-list>
    </van-pull-refresh> -->
  </div>
</template>

<script>
import { getVersionInfo } from '@/api/common.js'
export default {
  name: 'FeatureList',
  data() {
    return {
      isLoading: false,
      finished: false,
      loading: false,
      featureList: [],
      currentPage: 1
    }
  },
  created() {
    this.getVersionInfo()
  },
  methods: {
    async getVersionInfo() {
      const res = await getVersionInfo({ type: 'android' })
      const { data } = res
      this.featureList = data
    }
  }
}
</script>

<style lang="scss" scoped>
.feature{
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  height: auto;
  /deep/ .van-pull-refresh__track{
    min-height: calc(100vh - 46Px);
  }
}
.list{
  padding: 15px;
}
/deep/ .list .mr-timeline:last-child {
  .timeline-item_tail{
    display: none;
  }
}
</style>
